import { NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideTranslocoLocale } from '@ngneat/transloco-locale';
import { GoogleMapsModule } from '@rx-applications/shared/mapping/feature-shell';
import { CookieService } from 'ngx-cookie-service';
import { NgxWebstorageModule } from 'ngx-webstorage';

import { ENVIRONMENT_TOKEN } from '@rx-applications/shared/utils';

import { CustomCurrencyPipe, ToastModule } from '@roomex/rx-components';
import { CustomCurrencyPipe as SharedCustomCurrencyPipe} from '@rx-applications/shared/utils'

import { AuthModule, ErrorModule, PWAModule, TranslocoRootModule } from '@core/modules';
import { WINDOW_PROVIDERS } from '@core/services';
import { environment } from '@rx-applications/clientsite/shared/utils';
import { ClientsiteSharedInternationalizationDataAccessModule } from '@rx-applications/clientsite/shared/internationalization/data-access';
import { ClientsiteCoreLoggingModule, ClientsiteSharedLoggingService } from '@rx-applications/clientsite/core/logging';
import { BaseLogging } from '@rx-applications/shared/logging';
import { IntercomModule } from '@supy-io/ngx-intercom';
import { StoreModule } from '@rx-applications/shared/data-access';
import { ClientsiteSharedConfigDataAccessModule } from '@rx-applications/clientsite/shared/config/data-access';

@NgModule({
  imports: [
    // angular modules
    BrowserModule,
    BrowserAnimationsModule,
    // 3rd party modules
    NgxWebstorageModule.forRoot({
      prefix: `roomex-${environment.target}`,
      separator: '.',
    }),
    IntercomModule.forRoot({
      appId: '',
      updateOnRouterChange: true, // will automatically run `update` on router event changes. Default: `false`
    }),
    ToastModule,

    // app modules
    PWAModule,
    AuthModule,
    ClientsiteSharedConfigDataAccessModule,
    ErrorModule,
    ClientsiteSharedInternationalizationDataAccessModule,
    ClientsiteCoreLoggingModule,
    GoogleMapsModule,
    StoreModule,
    TranslocoRootModule,
  ],
  providers: [
    provideTranslocoLocale(),
    CookieService,
    SharedCustomCurrencyPipe,
    CustomCurrencyPipe,
    WINDOW_PROVIDERS,
    { provide: ENVIRONMENT_TOKEN, useValue: environment },
    { provide: BaseLogging, useExisting: ClientsiteSharedLoggingService },
  ],
})
export class CoreModule {
  // make sure CoreModule is imported only by one NgModule the AppModule
  constructor(
    @Optional() // because this dependency is not required
    @SkipSelf() // because we’re asking for a CoreModule dependency inside CoreModule!
    parentModule: CoreModule,
  ) {
    if (parentModule) {
      throw new Error('CoreModule has already been loaded. Import CoreModule in the AppModule only.');
    }
  }
}
